import React, { useState } from 'react';
import { AppDashboardNamedDataType } from '../../../../types/generated';
import Typography from '@material-ui/core/Typography';
import { bokunTheme } from '../../../../index';
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { getCountryNameByCode } from '../../../../utils/countryCodes';
import { useColorGenerator } from '../../../../hooks/useColorGenerator';

interface InstallsByCountryProps {
    installationsByCountry: AppDashboardNamedDataType[];
}

export const InstallsByCountry = ({
    installationsByCountry,
}: InstallsByCountryProps): JSX.Element => {
    const { convert } = useColorGenerator();
    const [country, setCountry] = useState('Top 10 installations by country');
    const [countryAmount, setCountryAmount] = useState('&nbsp;');

    const top10 = installationsByCountry
        .sort((a, b) => (a.amount > b.amount ? -1 : a.amount === b.amount ? 0 : 1))
        .slice(0, 10);

    const reset = () => {
        setCountry('Top 10 installations by country');
        setCountryAmount('&nbsp;');
    };

    return (
        <>
            <div>
                <Typography gutterBottom variant="h5" component="h2">
                    {country}
                </Typography>
                <Typography
                    gutterBottom
                    variant="h6"
                    component="h4"
                    style={{ color: bokunTheme.primary }}
                >
                    <span dangerouslySetInnerHTML={{ __html: countryAmount }} />
                </Typography>
            </div>
            <div onMouseLeave={reset}>
                <ResponsiveContainer height={150} width={'100%'}>
                    <BarChart data={top10}>
                        <Bar dataKey={'amount'}>
                            {top10.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={convert(entry.label)} />
                            ))}
                        </Bar>
                        <Tooltip
                            content={props => {
                                if (
                                    props !== null &&
                                    props.payload !== null &&
                                    props.payload.length > 0 &&
                                    props.payload[0]?.payload
                                ) {
                                    setCountry(
                                        getCountryNameByCode(props.payload[0].payload.label)
                                    );
                                    setCountryAmount(props.payload[0].payload.amount);
                                }

                                return null;
                            }}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </>
    );
};
